import { Link } from "react-router-dom";
import { ADDRESS, EMAIL, PHONE } from "../constants";
import { FaInstagram, FaLinkedin, FaGoogle, FaFacebook } from "react-icons/fa";
import { motion } from "framer-motion";

const Footer = () => {
  return (
    <footer className="relative bg-[#0A1620] text-[#CCE6F5] py-12 px-6 overflow-hidden">
      {/* Dark Theme Background */}
      <div className="absolute inset-0 bg-[#0A1620]"></div>

      {/* Premium Accent Gradients */}
      <div className="absolute top-40 right-0 w-[500px] h-[500px] bg-[#1B4D5E]/20 rounded-full blur-[120px]"></div>
      <div className="absolute bottom-40 left-0 w-[400px] h-[400px] bg-[#1A3B4D]/20 rounded-full blur-[100px]"></div>
      
      {/* Subtle Grid Pattern */}
      <div className="absolute inset-0 opacity-[0.02]">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `linear-gradient(to right, #2D5F7A 1px, transparent 1px), linear-gradient(to bottom, #2D5F7A 1px, transparent 1px)`,
            backgroundSize: "60px 60px",
          }}
        ></div>
      </div>

      {/* Top Wave */}
      <svg
        className="absolute top-0 left-0 w-full h-32 rotate-180 opacity-20"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
        preserveAspectRatio="none"
      >
        <path
          fill="#2D5F7A"
          fillOpacity="0.3"
          d="M0,192L48,176C96,160,192,128,288,128C384,128,480,160,576,176C672,192,768,192,864,176C960,160,1056,128,1152,128C1248,128,1344,160,1392,176L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
        ></path>
      </svg>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 lg:gap-12">
          {/* Company Intro - UPDATED WITH YOUR TEXT */}
          <div className="space-y-4">
            <h2 className="text-2xl md:text-3xl font-bold text-white tracking-wide">
              Salary<span className="text-[#7BC4E0]">mates</span>
            </h2>

            <p className="text-sm text-[#CCE6F5] leading-relaxed">
              At SalaryMates, we provide structured financial support solutions designed for salaried individuals who need quick assistance during urgent situations.
            </p>
            

            <div className="pt-2">
              <h3 className="text-base font-semibold text-white mb-3">Follow Us</h3>
              <div className="flex space-x-3">
                {[
                  { Icon: FaInstagram, link: "https://www.instagram.com/salarymatesofficial/" },
                  { Icon: FaLinkedin, link: "https://www.linkedin.com/company/salarymates/" },
                  { Icon: FaFacebook, link: "https://www.facebook.com/people/salarymates/" },
                  { Icon: FaGoogle, link: "https://www.salarymates.com/" },
                ].map(({ Icon, link }, i) => (
                  <motion.div
                    key={i}
                    whileHover={{ y: -3, scale: 1.1 }}
                    transition={{ type: "spring", stiffness: 400 }}
                  >
                    <Link
                      to={link}
                      target="_blank"
                      className="w-10 h-10 flex items-center justify-center
                        rounded-xl bg-gradient-to-br from-[#1A2F3A] to-[#0F2128]
                        border border-[#2D5F7A]/30
                        hover:border-[#7BC4E0]/50 hover:shadow-lg hover:shadow-[#7BC4E0]/10
                        transition-all duration-300 text-[#7BC4E0] hover:text-white"
                    >
                      <Icon className="text-sm" />
                    </Link>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>

          {/* Policies */}
          <div>
            <h3 className="text-base font-bold text-white mb-4 relative inline-block">
              Policies
              <span className="absolute -bottom-2 left-0 w-8 h-0.5 bg-gradient-to-r from-[#7BC4E0] to-transparent rounded-full"></span>
            </h3>
            <ul className="space-y-2">
              {[
                { name: "Corporate Governance", url: "/corporate-governance" },
                { name: "Fair Practice Code", url: "/fair-practice-code" },
                // { name: "Risk Management", url: "/risk-management" },
                { name: "Regulatory Approach & Compliance", url: "/regulatory-compliance" },
                { name: "Interest Rate", url: "/interest-rate" },
              ].map((item, i) => (
                <li key={i}>
                  <Link
                    to={item.url}
                    className="text-sm text-[#8FAFC7] hover:text-[#7BC4E0] hover:translate-x-1 inline-block transition-all duration-200"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-base font-bold text-white mb-4 relative inline-block">
              Quick Links
              <span className="absolute -bottom-2 left-0 w-8 h-0.5 bg-gradient-to-r from-[#7BC4E0] to-transparent rounded-full"></span>
            </h3>
            <ul className="space-y-2">
              {[
                { name: "Home", url: "/" },
                { name: "About Us", url: "/about-us" },
                { name: "Contact Us", url: "/contact" },
                { name: "Privacy Policy", url: "/privacypolicy" },
                { name: "Terms & Conditions", url: "/termsandconditions" },
              ].map((item, i) => (
                <li key={i}>
                  <Link
                    to={item.url}
                    className="text-sm text-[#8FAFC7] hover:text-[#7BC4E0] hover:translate-x-1 inline-block transition-all duration-200"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-base font-bold text-white mb-4 relative inline-block">
              Connect With Us
              <span className="absolute -bottom-2 left-0 w-8 h-0.5 bg-gradient-to-r from-[#7BC4E0] to-transparent rounded-full"></span>
            </h3>

            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <span className="text-[#7BC4E0] mt-0.5">📍</span>
                <span className="text-[#CCE6F5]">{ADDRESS}</span>
              </li>
              <li className="flex items-start gap-3">
  <span className="text-[#7BC4E0] mt-0.5">📍</span>
  <span className="text-[#CCE6F5]">
    Floor No.: Third Floor, Building No./Flat No.: 55 Third Floor,
    Road/Street: Saidulajab, Nearby Landmark: Westend Marg,
    Locality/Sub Locality: Saidulajab, City/Town/Village: New Delhi,
    District: South Delhi, State: Delhi, PIN Code: 110030
  </span>
</li>
              <li className="flex items-start gap-3">
                <span className="text-[#7BC4E0] mt-0.5">📧</span>
                <span className="text-[#CCE6F5]">{EMAIL}</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#7BC4E0] mt-0.5">📞</span>
                <span className="text-[#CCE6F5]">{PHONE}</span>
              </li>
            </ul>

           
          </div>
        </div>
{/* Copyright & Powered Section */}
<div className="mt-12 pt-6 border-t border-[#2D5F7A]/30 text-center">
 <p className="text-xs text-[#8FAFC7]">
    <span className="text-[#7BC4E0] font-semibold">SalaryMates</span> is an NBFC partner with{" "}
<span className="text-[#7BC4E0] font-semibold">V.N. Credits Limited</span>
  </p>
  <p className="text-xs text-[#8FAFC7] mt-1">
    RBI Registered NBFC &middot; CoR No. B-14.01330 &middot; CIN: U65929DL1997PLC085203
  </p>
</div>
        
      </div>

      {/* Bottom Wave */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden pointer-events-none opacity-20">
        <svg
          className="relative block w-full h-12"
          viewBox="0 0 1440 120"
          preserveAspectRatio="none"
        >
          <path
            fill="#2D5F7A"
            d="M0,64 C240,96 480,32 720,32 C960,32 1200,96 1440,64 L1440,120 L0,120 Z"
          />
        </svg>
      </div>
    </footer>
  );
};

export default Footer;